import { FC } from "react";

export const Divider: FC = () => (
  <div className="w-full py-8">
    <div className="bg-dark-100 h-[1px]" />
  </div>
);
